module.exports = __webpack_public_path__ + "assets/img/5232-un.svg";